import { render, staticRenderFns } from "./ArchivoPreviewRubrica.vue?vue&type=template&id=aafc8c3c&"
import script from "./ArchivoPreviewRubrica.vue?vue&type=script&lang=js&"
export * from "./ArchivoPreviewRubrica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports